<div class="page-container" fxLayout="column" fxLayoutAlign="center center" fxFlex>
  <div fxFlex class='not-found-code'>404</div>
  <div fxFlex class='not-found-text' i18n="NotFoundPage.Notes(notFoundText)@@page-not-found">Page not found</div>
  <span fxFlex class='message-text' i18n="NotFoundPage.Notes(messageText)@@sorry-but-the-page-you-are-requesting-doesn-t-exist">Sorry, but the page you are requesting doesn't exist</span>
  <button mat-raised-button color='primary' routerLink="/" i18n="NotFoundPage.Button@@go-home">Go home</button>
</div>
